import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { paths } from '@constants/paths';
import { BundleBasketFragment } from '@generated/gql/graphql';
import {
  energyDetailsValidator,
  yourDetailsValidator,
} from '@utils/basketStatusValidation';

const isBasketValid = (validator: 'energyDetails' | 'yourDetails') => {
  if (validator === 'energyDetails') {
    return energyDetailsValidator;
  }

  return yourDetailsValidator;
};

const useRedirectOnInvalidSelection = (
  basket: Nullable<BundleBasketFragment>,
  validator: 'energyDetails' | 'yourDetails',
  fallbackPath: string = paths.bundle
) => {
  const navigate = useNavigate();
  const basketStatus = basket?.basketStatus;

  useEffect(() => {
    if (!basketStatus || isBasketValid(validator)(basketStatus)) {
      return;
    }

    navigate(fallbackPath);
  }, [basketStatus, navigate, validator, fallbackPath]);
};

export { useRedirectOnInvalidSelection };
